<template>
    <section class="l-section l-section--main o-dashboard">
        <div class="l-container l-container--main o-dashboard__container">
            <dashboard-tabs />
            <router-view></router-view>
        </div>
    </section>
</template>

<script>
import DashboardTabs from '@/components/dashboard/DashboardTabs'
export default {
    components: {
        DashboardTabs
    }
}
</script>
